import { useEffect, useState } from "react";
import { calculateOpeningTimes } from "../utils/datetime/calculateOpeningTimes";

const useOpeningTimesMessage = ({ hours }) => {
    const [displayOpen, setDisplayOpen] = useState("");

    useEffect(() => {
        calculateOpeningTimes(setDisplayOpen, hours);
    }, [hours]);

    return displayOpen;
};

export default useOpeningTimesMessage;
